export enum SignedUrlTypes {
  SIGNED_URLS_REQUEST = 'SIGNED_URLS_REQUEST',
  SIGNED_URLS_SUCCESS = 'SIGNED_URLS_SUCCESS',
  SIGNED_URLS_ERROR = 'SIGNED_URLS_ERROR',
  RESET_SIGNED_URLS = 'RESET_SIGNED_URLS',
  RESET_SIGNED_URLS_ERROR = 'RESET_SIGNED_URLS_ERROR',
}

export interface GetSingleSignedUrlsInput {
  formats: string[];
  prefix: string;
}

export interface SignedUrl {
  signedUrl: string;
  url: string;
}

export interface SignedUrls {
  type: SignedUrlTypes.SIGNED_URLS_REQUEST;
  input: GetSingleSignedUrlsInput;
}

export interface SignedUrlsSuccess {
  type: SignedUrlTypes.SIGNED_URLS_SUCCESS;
  signedUrls: SignedUrl[];
}

export interface SignedUrlsError {
  type: SignedUrlTypes.SIGNED_URLS_ERROR;
  error: Error;
}

export interface ResetSignedUrls {
  type: SignedUrlTypes.RESET_SIGNED_URLS;
}

export interface ResetSignedUrlsError {
  type: SignedUrlTypes.RESET_SIGNED_URLS_ERROR;
}

export type SignedUrlAction = SignedUrls | SignedUrlsSuccess | SignedUrlsError | ResetSignedUrls | ResetSignedUrlsError;
